import Modal from "../Helpers/UI/Modal";
import { blockScroll, unblockScroll } from "../Helpers/helpers";

export default () => ({
    open() {
        let minicartModal = Modal.getModalByName("minicart");
        minicartModal.delay = 500;
        minicartModal.onOpened = (modal) => {
            modal.getModalElement().classList.remove("tw-translate-x-full");
            blockScroll();
        };
        minicartModal.onClosing = (modal) => {
            modal.getModalElement().classList.add("tw-translate-x-full");
            unblockScroll();
        };
        minicartModal.show();
    },
});
